import { PriceLabelEnum } from '@/enums/PriceLabelEnum'
import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { zDiscountRowTypeEnum } from '@/schemas/discountRowTypeEnumSchema'

import type { DiscountRowTypeEnum as ResponseDto } from '@/gen/bff'
import type { DiscountRowTypeEnumSchema } from '@/schemas/discountRowTypeEnumSchema'

export const discountRowTypeEnumConverter = (data?: ResponseDto): DiscountRowTypeEnumSchema => {
  const response: DiscountRowTypeEnumSchema = (() => {
    switch (data) {
      case 'APPROPRIATION': {
        return PriceLabelEnum.APPROPRIATION
      }
      case 'GREEN_ORDINATION': {
        return PriceLabelEnum.GREEN_ORDINATION
      }
      case 'AGREEMENT_GROUP': {
        return PriceLabelEnum.AGREEMENT_GROUP
      }
      case 'CAMPAIGN_PART': {
        return PriceLabelEnum.CAMPAIGN_PART
      }
      case 'CAMPAIGN_SALES_PROMOTION_NODE': {
        return PriceLabelEnum.CAMPAIGN_SALES_PROMOTION_NODE
      }
      case 'CAMPAIGN_SALES_PROMOTION_PART': {
        return PriceLabelEnum.CAMPAIGN_SALES_PROMOTION_PART
      }
      default:
        return null
    }
  })()

  return zDiscountRowTypeEnum.catch(defaultZodCatch).parse(response)
}
